<template>
  <Layout>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length"></div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <b-button
                    v-if="user_permissions.add_suppliers"
                    v-b-modal.supplier-modal
                    variant="primary"
                    ><i class="fa fa-plus"></i> New Supplier
                  </b-button>
                  <b-button v-else disabled v-b-modal.supplier-modal variant="primary"
                    ><i class="fa fa-plus"></i> New Supplier
                  </b-button>
                  <!--ADDING NEW SERVICE MODAL-->
                  <b-modal
                    id="supplier-modal"
                    centered
                    ref="modal"
                    hide-footer
                    title="Add New Supplier"
                    @hidden="resetAddModal"
                  >
                    <form ref="form" @submit.stop.prevent="saveSupplier">
                      <div class="mb-3">
                        <label class="col-form-label" for="supplier-name"
                          >Supplier Name:</label
                        >
                        <input
                          id="supplier-name"
                          v-model="data.name"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g Kampala Pharmaceuticals Uganda Ltd"
                        />
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="s-phone"
                          >Service Contact:</label
                        >
                        <input
                          id="s-phone"
                          @keyup="checkName"
                          v-model="data.contact"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g 0777489393"
                        />
                        <div class="text-danger" v-if="contactError">
                          <em>{{ contactError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="e-mail">Supplier Email:</label>
                        <input
                          id="e-mail"
                          v-model="data.email"
                          class="form-control"
                          required
                          type="email"
                          placeholder="E.g info@example.com"
                        />
                        <div class="text-danger" v-if="emailError">
                          <em>{{ emailError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="address"
                          >Supplier Address:</label
                        >
                        <input
                          id="address"
                          v-model="data.address"
                          class="form-control"
                          required
                          type="email"
                          placeholder="E.g Kampala, Uganda"
                        />
                        <div class="text-danger" v-if="addressError">
                          <em>{{ addressError }}</em>
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('supplier-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingSupplier.length"
                        class="btn btn-info"
                        disabled
                        title="This Service already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="handleAddModal"
                      >
                        Save Service
                      </button>
                    </div>
                  </b-modal>

                  <!--EDITING SERVICE MODAL-->
                  <b-modal
                    id="edit-modal"
                    centered
                    ref="modal"
                    hide-footer
                    :title="editData.name"
                    @hidden="resetEditModal"
                  >
                    <form ref="form" @submit.stop.prevent="saveChanges">
                      <div class="mb-3">
                        <label class="col-form-label" for="edit-name"
                          >Supplier Name:</label
                        >
                        <input
                          id="edit-name"
                          v-model="editData.name"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g Kampala Pharmaceuticals Uganda Ltd"
                        />
                        <div class="text-danger" v-if="nameError">
                          <em>{{ nameError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="phone">Service Contact:</label>
                        <input
                          id="phone"
                          @keyup="checkName"
                          v-model="editData.contact"
                          class="form-control"
                          required
                          type="text"
                          placeholder="E.g 0777489393"
                        />
                        <div class="text-danger" v-if="contactError">
                          <em>{{ contactError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="email">Supplier Email:</label>
                        <input
                          id="email"
                          v-model="editData.email"
                          class="form-control"
                          required
                          type="email"
                          placeholder="E.g info@example.com"
                        />
                        <div class="text-danger" v-if="emailError">
                          <em>{{ emailError }}</em>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="col-form-label" for="local"
                          >Supplier Address:</label
                        >
                        <input
                          id="local"
                          v-model="editData.address"
                          class="form-control"
                          required
                          type="email"
                          placeholder="E.g Kampala, Uganda"
                        />
                        <div class="text-danger" v-if="addressError">
                          <em>{{ addressError }}</em>
                        </div>
                      </div>
                    </form>
                    <div class="modal-footer">
                      <button
                        class="btn btn-secondary"
                        @click="$bvModal.hide('edit-modal')"
                        type="button"
                      >
                        Close
                      </button>
                      <button
                        v-if="existingSupplier.length"
                        class="btn btn-info"
                        disabled
                        title="This Service already exists"
                        type="button"
                      >
                        <i class="fa fa-ban"></i> Save Service
                      </button>
                      <button
                        v-else
                        class="btn btn-primary"
                        type="button"
                        @click="handleEditModal"
                      >
                        Save Changes
                      </button>
                    </div>
                  </b-modal>

                  <!--DELETING SERVICE MODAL-->
                  <b-modal
                    id="delete-modal"
                    header-bg-variant="warning"
                    header-text-variant="light"
                    ref="modal"
                    size="sm"
                    centered
                    title="Confirmation Alert"
                    @hidden="resetDeleteModal"
                    @ok="confirmDelete"
                  >
                    <div class="d-block text-center">
                      <h5>
                        Are you sure you want to delete
                        <code>{{ this.deleteData.name }}</code
                        >? <br />
                        Click <code>OK</code> to continue
                      </h5>
                    </div>
                  </b-modal>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.Suppliers"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(action)="data">
                  <!-- Edit Modal -->
                  <b-button
                    v-if="user_permissions.edit_suppliers"
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  <b-button
                    v-else
                    disabled
                    v-b-modal.edit-modal
                    size="sm"
                    variant="primary"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                  </b-button>
                  |
                  <!-- Delete Modal -->
                  <b-button
                    v-if="user_permissions.delete_suppliers"
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                  <b-button
                    v-else
                    disabled
                    v-b-modal.delete-modal
                    size="sm"
                    variant="danger"
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.Suppliers" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions } from "vuex";

export default {
  page: {
    title: "Pharmacy Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Suppliers",
      items: [
        {
          text: "Pharmacy Section",
          href: "#",
        },
        {
          text: "Facility Suppliers",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "SUPPLIER NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "PHONE NUMBER",
        },
        {
          key: "email",
          sortable: true,
          label: "EMAIL ADDRESS",
        },
        {
          key: "address",
          sortable: true,
          label: "LOCATION",
        },
        {
          key: "dateCreated",
          sortable: true,
          label: "DATE & TIME",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      data: {
        name: "",
        contact: "",
        email: "",
        address: "",
      },
      existingSupplier: [],
      nameError: "",
      contactError: "",
      emailError: "",
      addressError: "",
      editData: {
        name: "",
        contact: "",
        email: "",
        address: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
    };
  },

  computed: {
    ...mapGetters("pharmacy", ["Suppliers"]),
    ...mapGetters("auth", ["user_permissions"]),

    rows() {
      return this.Suppliers ? this.Suppliers.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Suppliers ? this.Suppliers.length : 1;
  },
  methods: {
    ...mapActions({
      FetchSuppliers: "pharmacy/fetchSuppliers",
      SubmitSupplier: "pharmacy/saveSupplier",
      SubmitUpdates: "pharmacy/updateSupplier",
      DeleteService: "pharmacy/deleteSupplier",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingSupplier = this.Suppliers.filter((supplier) => {
          return supplier.contact.toUpperCase() == this.data.contact.toUpperCase();
        });
        if (this.existingSupplier.length) {
          this.contactError = "Supplier with " + this.data.contact + " exists already";
        } else {
          this.contactError = "";
        }
      } else {
        this.existingSupplier = [];
      }
    },

    handleAddModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.saveSupplier();
    },

    saveSupplier() {
      //Now validate for required fields
      if (this.data.name == "") {
        this.nameError = "Supplier name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.contact == "") {
        this.contactError = "Supplier contact is required";
        return;
      } else {
        this.contactError = "";
      }
      if (this.data.email == "") {
        this.emailError = "Supplier email is required";
        return;
      } else {
        this.emailError = "";
      }
      if (this.data.address == "") {
        this.addressError = "Supplier address is required";
        return;
      } else {
        this.addressError = "";
      }

      // Push the data submitted to the endpoint
      this.SubmitSupplier(this.data);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("supplier-modal");
      });
    },

    //Now reset the add modal
    resetAddModal() {
      this.data.name = "";
      this.data.contact = "";
      this.data.email = "";
      this.data.address = "";

      this.nameError = "";
      this.contactError = "";
      this.addressError = "";
      this.emailError = "";

      this.existingSupplier = [];
    },

    showEditModal(data) {
      this.editData.id = data.item.id;
      this.editData.name = data.item.name;
      this.editData.contact = data.item.contact;
      this.editData.email = data.item.email;
      this.editData.address = data.item.address;
    },

    handleEditModal(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.saveChanges();
    },

    saveChanges() {
      //Now validate for required fields
      if (this.editData.name == "") {
        this.nameError = "Service name is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editData.contact == "") {
        this.contactError = "Supplier phone is required";
        return;
      } else {
        this.contactError = "";
      }
      if (this.editData.email == "") {
        this.emailError = "Supplier email is required";
        return;
      } else {
        this.emailError = "";
      }
      if (this.editData.address == "") {
        this.addressError = "Supplier address is required";
        return;
      } else {
        this.addressError = "";
      }

      // Push the data submitted to the endpoint
      this.SubmitUpdates(this.editData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("edit-modal");
      });
    },

    resetEditModal() {
      this.data.name = "";
      this.data.contact = "";
      this.data.email = "";
      this.data.address = "";

      this.nameError = "";
      this.contactError = "";
      this.addressError = "";
      this.emailError = "";

      this.existingSupplier = [];
    },

    showDeleteModal(data) {
      this.deleteData.name = data.item.name;
      this.deleteData.id = data.item.id;
    },

    confirmDelete() {
      // Push the data submitted to the endpoint
      this.DeleteService(this.deleteData);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("delete-modal");
      });
    },

    resetDeleteModal() {
      this.deleteData.id = "";
      this.deleteData.name = "";
    },
  },

  created() {
    this.FetchSuppliers();
  },
};
</script>
<style lang="css" scoped></style>
